!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactDropdownTreeSelect", ["react"], t) : "object" == typeof exports ? exports.ReactDropdownTreeSelect = t(require("react")) : e.ReactDropdownTreeSelect = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 9);
  }([function (e, t, n) {
    e.exports = n(15)();
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    var r;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var a = typeof r;
            if ("string" === a || "number" === a) e.push(this && this[r] || r);else if (Array.isArray(r)) e.push(o.apply(this, r));else if ("object" === a) for (var i in r) {
              n.call(r, i) && r[i] && e.push(this && this[i] || i);
            }
          }
        }

        return e.join(" ");
      }

      void 0 !== e && e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    e.exports = function (e, t) {
      var n = e.filter(t);
      return 0 !== n.length && n.length !== e.length;
    };
  }, function (e, t, n) {
    var r;
    r = function r(e) {
      return function (e) {
        var t = {};

        function n(r) {
          if (t[r]) return t[r].exports;
          var o = t[r] = {
            exports: {},
            id: r,
            loaded: !1
          };
          return e[r].call(o.exports, o, o.exports, n), o.loaded = !0, o.exports;
        }

        return n.m = e, n.c = t, n.p = "", n(0);
      }([function (e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        },
            o = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            a = function a(e, t, n) {
          for (var r = !0; r;) {
            var o = e,
                a = t,
                i = n;
            r = !1, null === o && (o = Function.prototype);
            var l = Object.getOwnPropertyDescriptor(o, a);

            if (void 0 !== l) {
              if ("value" in l) return l.value;
              var s = l.get;
              if (void 0 === s) return;
              return s.call(i);
            }

            var c = Object.getPrototypeOf(o);
            if (null === c) return;
            e = c, t = a, n = i, r = !0, l = c = void 0;
          }
        };

        function i(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        var l = n(8),
            s = i(l),
            c = i(n(6)),
            u = i(n(2)),
            h = n(1),
            p = function (e) {
          function t(e) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t), a(Object.getPrototypeOf(t.prototype), "constructor", this).call(this), this.state = {
              showLoader: !1,
              lastScrollTop: 0,
              actionTriggered: !1,
              pullToRefreshThresholdBreached: !1
            }, this.startY = 0, this.currentY = 0, this.dragging = !1, this.maxPullDownDistance = 0, this.onScrollListener = this.onScrollListener.bind(this), this.throttledOnScrollListener = (0, u.default)(this.onScrollListener, 150).bind(this), this.onStart = this.onStart.bind(this), this.onMove = this.onMove.bind(this), this.onEnd = this.onEnd.bind(this), this.getScrollableTarget = this.getScrollableTarget.bind(this);
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, l.Component), o(t, [{
            key: "componentDidMount",
            value: function value() {
              if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el.addEventListener("scroll", this.throttledOnScrollListener), "number" == typeof this.props.initialScrollY && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown.firstChild.getBoundingClientRect().height, this.forceUpdate(), "function" != typeof this.props.refreshFunction)) throw new Error('Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\'');
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd));
            }
          }, {
            key: "componentWillReceiveProps",
            value: function value(e) {
              this.props.dataLength !== e.dataLength && this.setState({
                showLoader: !1,
                actionTriggered: !1,
                pullToRefreshThresholdBreached: !1
              });
            }
          }, {
            key: "getScrollableTarget",
            value: function value() {
              return this.props.scrollableTarget instanceof HTMLElement ? this.props.scrollableTarget : "string" == typeof this.props.scrollableTarget ? document.getElementById(this.props.scrollableTarget) : (null === this.props.scrollableTarget && console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      "), null);
            }
          }, {
            key: "onStart",
            value: function value(e) {
              this.state.lastScrollTop || (this.dragging = !0, this.startY = e.pageY || e.touches[0].pageY, this.currentY = this.startY, this._infScroll.style.willChange = "transform", this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)");
            }
          }, {
            key: "onMove",
            value: function value(e) {
              this.dragging && (this.currentY = e.pageY || e.touches[0].pageY, this.currentY < this.startY || (this.currentY - this.startY >= this.props.pullDownToRefreshThreshold && this.setState({
                pullToRefreshThresholdBreached: !0
              }), this.currentY - this.startY > 1.5 * this.maxPullDownDistance || (this._infScroll.style.overflow = "visible", this._infScroll.style.transform = "translate3d(0px, " + (this.currentY - this.startY) + "px, 0px)")));
            }
          }, {
            key: "onEnd",
            value: function value(e) {
              var t = this;
              this.startY = 0, this.currentY = 0, this.dragging = !1, this.state.pullToRefreshThresholdBreached && this.props.refreshFunction && this.props.refreshFunction(), requestAnimationFrame(function () {
                t._infScroll.style.overflow = "auto", t._infScroll.style.transform = "none", t._infScroll.style.willChange = "none";
              });
            }
          }, {
            key: "isElementAtBottom",
            value: function value(e) {
              var t = arguments.length <= 1 || void 0 === arguments[1] ? .8 : arguments[1],
                  n = e === document.body || e === document.documentElement ? window.screen.availHeight : e.clientHeight,
                  r = (0, h.parseThreshold)(t);
              return r.unit === h.ThresholdUnits.Pixel ? e.scrollTop + n >= e.scrollHeight - r.value : e.scrollTop + n >= r.value / 100 * e.scrollHeight;
            }
          }, {
            key: "onScrollListener",
            value: function value(e) {
              var t = this;
              "function" == typeof this.props.onScroll && setTimeout(function () {
                return t.props.onScroll(e);
              }, 0);
              var n = this.props.height || this._scrollableNode ? e.target : document.documentElement.scrollTop ? document.documentElement : document.body;
              this.state.actionTriggered || (this.isElementAtBottom(n, this.props.scrollThreshold) && this.props.hasMore && (this.setState({
                actionTriggered: !0,
                showLoader: !0
              }), this.props.next()), this.setState({
                lastScrollTop: n.scrollTop
              }));
            }
          }, {
            key: "render",
            value: function value() {
              var e = this,
                  t = r({
                height: this.props.height || "auto",
                overflow: "auto",
                WebkitOverflowScrolling: "touch"
              }, this.props.style),
                  n = this.props.hasChildren || !(!this.props.children || !this.props.children.length),
                  o = this.props.pullDownToRefresh && this.props.height ? {
                overflow: "auto"
              } : {};
              return s.default.createElement("div", {
                style: o
              }, s.default.createElement("div", {
                className: "infinite-scroll-component",
                ref: function ref(t) {
                  return e._infScroll = t;
                },
                style: t
              }, this.props.pullDownToRefresh && s.default.createElement("div", {
                style: {
                  position: "relative"
                },
                ref: function ref(t) {
                  return e._pullDown = t;
                }
              }, s.default.createElement("div", {
                style: {
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: -1 * this.maxPullDownDistance
                }
              }, !this.state.pullToRefreshThresholdBreached && this.props.pullDownToRefreshContent, this.state.pullToRefreshThresholdBreached && this.props.releaseToRefreshContent)), this.props.children, !this.state.showLoader && !n && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
            }
          }]), t;
        }();

        t.default = p, p.defaultProps = {
          pullDownToRefreshContent: s.default.createElement("h3", null, "Pull down to refresh"),
          releaseToRefreshContent: s.default.createElement("h3", null, "Release to refresh"),
          pullDownToRefreshThreshold: 100,
          disableBrowserPullToRefresh: !0
        }, p.propTypes = {
          next: c.default.func,
          hasMore: c.default.bool,
          children: c.default.node,
          loader: c.default.node.isRequired,
          scrollThreshold: c.default.oneOfType([c.default.number, c.default.string]),
          endMessage: c.default.node,
          style: c.default.object,
          height: c.default.number,
          scrollableTarget: c.default.node,
          hasChildren: c.default.bool,
          pullDownToRefresh: c.default.bool,
          pullDownToRefreshContent: c.default.node,
          releaseToRefreshContent: c.default.node,
          pullDownToRefreshThreshold: c.default.number,
          refreshFunction: c.default.func,
          onScroll: c.default.func,
          dataLength: c.default.number.isRequired
        }, e.exports = t.default;
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.parseThreshold = function (e) {
          if ("number" == typeof e) return {
            unit: n.Percent,
            value: 100 * e
          };
          if ("string" == typeof e) return e.match(/^(\d*(.\d+)?)px$/) ? {
            unit: n.Pixel,
            value: parseFloat(e)
          } : e.match(/^(\d*(.\d+)?)%$/) ? {
            unit: n.Percent,
            value: parseFloat(e)
          } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), r);
          return console.warn("scrollThreshold should be string or number"), r;
        };
        var n = {
          Pixel: "Pixel",
          Percent: "Percent"
        };
        t.ThresholdUnits = n;
        var r = {
          unit: n.Percent,
          value: .8
        };
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function (e, t, n) {
          var r, o;
          return t || (t = 250), function () {
            var a = n || this,
                i = +new Date(),
                l = arguments;
            r && i < r + t ? (clearTimeout(o), o = setTimeout(function () {
              r = i, e.apply(a, l);
            }, t)) : (r = i, e.apply(a, l));
          };
        }, e.exports = t.default;
      }, function (e, t) {
        "use strict";

        function n(e) {
          return function () {
            return e;
          };
        }

        var r = function r() {};

        r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
          return this;
        }, r.thatReturnsArgument = function (e) {
          return e;
        }, e.exports = r;
      }, function (e, t, n) {
        "use strict";

        var r = function r(e) {};

        e.exports = function (e, t, n, o, a, i, l, s) {
          if (r(t), !e) {
            var c;
            if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
              var u = [n, o, a, i, l, s],
                  h = 0;
              (c = new Error(t.replace(/%s/g, function () {
                return u[h++];
              }))).name = "Invariant Violation";
            }
            throw c.framesToPop = 1, c;
          }
        };
      }, function (e, t, n) {
        "use strict";

        var r = n(3),
            o = n(4),
            a = n(7);

        e.exports = function () {
          function e(e, t, n, r, i, l) {
            l !== a && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          }

          function t() {
            return e;
          }

          e.isRequired = e;
          var n = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t
          };
          return n.checkPropTypes = r, n.PropTypes = n, n;
        };
      }, function (e, t, n) {
        e.exports = n(5)();
      }, function (e, t) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, function (t, n) {
        t.exports = e;
      }]);
    }, e.exports = r(n(1));
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n.r(t);

    var r = n(2),
        o = n.n(r),
        a = n(0),
        i = n.n(a),
        l = n(1),
        s = n.n(l),
        c = function c() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return Object.keys(e).reduce(function (t, n) {
        var r;
        return t["data-" + (r = n, r.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase())] = e[n], t;
      }, {});
    },
        u = (function () {}(), function (e) {
      return !e || Array.isArray(e) && !e.length;
    }),
        h = function h(e, t) {
      if (!(e instanceof Event)) return !1;
      var n = t ? t + " react-dropdown-tree-select" : "react-dropdown-tree-select";
      return !function (e) {
        if (e.path) return e.path;

        for (var t = e.target, n = [t]; t.parentElement;) {
          t = t.parentElement, n.unshift(t);
        }

        return n;
      }(e).some(function (e) {
        return e.className && e.className.indexOf(n) >= 0;
      });
    },
        p = function p(e, t) {
      var n = void 0;
      return function () {
        for (var r = arguments.length, o = Array(r), a = 0; a < r; a++) {
          o[a] = arguments[a];
        }

        var i = !n;
        clearTimeout(n), n = setTimeout(function () {
          n = null, e.apply(void 0, o);
        }, t), i && e.apply(void 0, o);
      };
    },
        d = n(8),
        f = n.n(d),
        y = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function b(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var g = o.a.bind(f.a),
        v = function (e) {
      function t() {
        var e, n, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
          a[i] = arguments[i];
        }

        return n = r = b(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), r.handleClick = function (e) {
          var t = r.props,
              n = t.id,
              o = t.onDelete;
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), o(n);
        }, b(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), y(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.label,
              n = e.readOnly;
          return s.a.createElement("span", {
            className: g("tag")
          }, t, s.a.createElement("button", {
            onClick: !n && this.handleClick,
            className: g("tag-remove", {
              readOnly: n
            }),
            type: "button"
          }, "x"));
        }
      }]), t;
    }();

    v.propTypes = {
      id: i.a.string.isRequired,
      label: i.a.string.isRequired,
      onDelete: i.a.func,
      readOnly: i.a.bool
    };

    var m = v,
        O = n(7),
        w = n.n(O),
        T = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        _ = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var k = o.a.bind(w.a),
        S = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.handleInputChange = function (e) {
          e.persist(), n.delayedCallback(e);
        }, n.delayedCallback = p(function (e) {
          return n.props.onInputChange(e.target.value);
        }, 300), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), T(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.tags,
              n = e.onTagRemove,
              r = e.inputRef,
              o = e.placeholderText,
              a = void 0 === o ? "Choose..." : o,
              i = e.onFocus,
              l = e.onBlur,
              u = e.disabled,
              h = e.readOnly;
          return s.a.createElement("ul", {
            className: k("tag-list")
          }, function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                t = arguments[1],
                n = arguments[2];
            return e.map(function (e) {
              var r = e._id,
                  o = e.label,
                  a = e.tagClassName,
                  i = e.dataset;
              return s.a.createElement("li", _({
                className: k("tag-item", a),
                key: "tag-item-" + r
              }, c(i)), s.a.createElement(m, {
                label: o,
                id: r,
                onDelete: t,
                readOnly: n
              }));
            });
          }(t, n, h), s.a.createElement("li", {
            className: k("tag-item")
          }, s.a.createElement("input", {
            type: "text",
            disabled: u,
            ref: r,
            className: k("search"),
            placeholder: a,
            onChange: this.handleInputChange,
            onFocus: i,
            onBlur: l,
            readOnly: h
          })));
        }
      }]), t;
    }();

    S.propTypes = {
      tags: i.a.array,
      placeholderText: i.a.string,
      onInputChange: i.a.func,
      onFocus: i.a.func,
      onBlur: i.a.func,
      onTagRemove: i.a.func,
      inputRef: i.a.func,
      disabled: i.a.bool,
      readOnly: i.a.bool
    };

    var P = S,
        C = n(6),
        E = n.n(C),
        x = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function j(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var N = function (e) {
      function t() {
        var e, n, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
          a[i] = arguments[i];
        }

        return n = r = j(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), r.handleClick = function () {
          r.props.onAction(r.props.actionData);
        }, j(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), x(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.title,
              n = e.className,
              r = e.text,
              o = e.readOnly;
          return s.a.createElement("i", {
            title: t,
            className: n,
            onClick: !o && this.handleClick
          }, r);
        }
      }]), t;
    }();

    N.propTypes = {
      title: i.a.string,
      text: i.a.string,
      className: i.a.string,
      actionData: i.a.object,
      onAction: i.a.func,
      readOnly: i.a.bool
    }, N.defaultProps = {
      onAction: function onAction() {}
    };

    var R = N,
        M = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        D = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var L = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), D(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.actions,
              n = e.id,
              r = function (e, t) {
            var n = {};

            for (var r in e) {
              t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
            }

            return n;
          }(e, ["actions", "id"]);

          return u(t) ? null : t.map(function (e, t) {
            var o = e.id || "action-" + t;
            return s.a.createElement(R, M({
              key: o
            }, r, e, {
              actionData: {
                action: o,
                id: n
              }
            }));
          });
        }
      }]), t;
    }();

    L.propTypes = {
      id: i.a.string.isRequired,
      actions: i.a.array
    };

    var I = L,
        B = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        A = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Y(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var F = function (e) {
      function t() {
        var e, n, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
          a[i] = arguments[i];
        }

        return n = r = Y(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), r.handleChange = function (e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), r.props.onChange(e);
        }, Y(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), A(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.checked,
              n = e.indeterminate,
              r = void 0 !== n && n,
              o = (e.onChange, e.disabled),
              a = e.readOnly,
              i = function (e, t) {
            var n = {};

            for (var r in e) {
              t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
            }

            return n;
          }(e, ["checked", "indeterminate", "onChange", "disabled", "readOnly"]),
              l = o || a;

          return s.a.createElement("input", B({
            type: "checkbox",
            ref: function (e) {
              var t = e.checked,
                  n = e.indeterminate;
              return function (e) {
                e && (e.checked = t, e.indeterminate = n);
              };
            }({
              checked: t,
              indeterminate: r
            }),
            onChange: this.handleChange,
            disabled: l
          }, i));
        }
      }]), t;
    }();

    F.propTypes = {
      checked: i.a.bool,
      indeterminate: i.a.bool,
      onChange: i.a.func,
      disabled: i.a.bool,
      readOnly: i.a.bool
    };

    var V = F,
        q = n(3),
        H = n.n(q),
        W = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function U(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var z = o.a.bind(H.a),
        $ = function (e) {
      function t() {
        var e, n, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
          a[i] = arguments[i];
        }

        return n = r = U(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), r.handleCheckboxChange = function (e) {
          var t = r.props,
              n = t.simpleSelect,
              o = t.id,
              a = t.onCheckboxChange;
          n ? a(o, !0) : a(o, e.target.checked);
        }, U(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), W(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.simpleSelect,
              n = e.title,
              r = e.label,
              o = e.id,
              a = e.partial,
              i = e.checked,
              l = e.value,
              c = e.disabled,
              u = e.showPartiallySelected,
              h = e.readOnly,
              p = {
            className: "node-label"
          };
          return t && !h && (p.onClick = this.handleCheckboxChange), s.a.createElement("label", {
            title: n || r,
            htmlFor: o
          }, s.a.createElement(V, {
            name: o,
            id: o,
            indeterminate: u && a,
            className: z("checkbox-item", {
              "simple-select": t
            }),
            checked: i,
            onChange: this.handleCheckboxChange,
            value: l,
            disabled: c,
            readOnly: h
          }), s.a.createElement("span", p, r));
        }
      }]), t;
    }();

    $.propTypes = {
      id: i.a.string.isRequired,
      actions: i.a.array,
      title: i.a.string,
      label: i.a.string.isRequired,
      value: i.a.string.isRequired,
      checked: i.a.bool,
      partial: i.a.bool,
      expanded: i.a.bool,
      disabled: i.a.bool,
      dataset: i.a.object,
      simpleSelect: i.a.bool,
      showPartiallySelected: i.a.bool,
      onCheckboxChange: i.a.func,
      readOnly: i.a.bool
    };

    var J = $,
        Z = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function G(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var K = o.a.bind(H.a),
        Q = function (e) {
      function t() {
        var e, n, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
          a[i] = arguments[i];
        }

        return n = r = G(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), r.onToggle = function () {
          r.props.onNodeToggle(r.props.id);
        }, G(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), Z(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.expanded,
              n = e.isLeaf,
              r = K("toggle", {
            expanded: !n && t,
            collapsed: !n && !t
          });
          return s.a.createElement("i", {
            className: r,
            onClick: this.onToggle
          });
        }
      }]), t;
    }();

    Q.propTypes = {
      expanded: i.a.bool,
      isLeaf: i.a.bool,
      onNodeToggle: i.a.func,
      id: i.a.string
    };

    var X = Q,
        ee = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        te = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var ne = o.a.bind(H.a),
        re = function re(e) {
      return u(e);
    },
        oe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["PureComponent"]), te(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.simpleSelect,
              n = e.keepTreeOnSearch,
              r = e._id,
              o = e._children,
              a = e.dataset,
              i = e._depth,
              l = e.expanded,
              u = e.title,
              h = e.label,
              p = e.partial,
              d = e.checked,
              f = e.value,
              y = e.disabled,
              b = e.actions,
              g = e.onAction,
              v = e.searchModeOn,
              m = e.onNodeToggle,
              O = e.onCheckboxChange,
              w = e.showPartiallySelected,
              T = e.readOnly,
              _ = function (e) {
            var t = e.keepTreeOnSearch,
                n = e.keepChildrenOnSearch,
                r = e._children,
                o = e.matchInChildren,
                a = e.matchInParent,
                i = e.disabled,
                l = e.partial,
                s = e.hide,
                c = e.className,
                u = e.showPartiallySelected,
                h = e.readOnly;
            return ne("node", {
              leaf: re(r),
              tree: !re(r),
              disabled: i,
              hide: s,
              "match-in-children": t && o,
              "match-in-parent": t && n && a,
              partial: u && l,
              readOnly: h
            }, c);
          }(this.props),
              k = n || !v ? {
            paddingLeft: 20 * (i || 0) + "px"
          } : {};

          return s.a.createElement("li", ee({
            className: _,
            style: k
          }, c(a)), s.a.createElement(X, {
            isLeaf: re(o),
            expanded: l,
            id: r,
            onNodeToggle: m
          }), s.a.createElement(J, {
            title: u,
            label: h,
            id: r,
            partial: p,
            checked: d,
            value: f,
            disabled: y,
            simpleSelect: t,
            onCheckboxChange: O,
            showPartiallySelected: w,
            readOnly: T
          }), s.a.createElement(I, {
            actions: b,
            onAction: g,
            id: r,
            readOnly: T
          }));
        }
      }]), t;
    }();

    oe.propTypes = {
      _id: i.a.string.isRequired,
      _depth: i.a.number,
      _children: i.a.array,
      actions: i.a.array,
      className: i.a.string,
      title: i.a.string,
      label: i.a.string.isRequired,
      value: i.a.string.isRequired,
      checked: i.a.bool,
      expanded: i.a.bool,
      disabled: i.a.bool,
      partial: i.a.bool,
      dataset: i.a.object,
      keepTreeOnSearch: i.a.bool,
      keepChildrenOnSearch: i.a.bool,
      searchModeOn: i.a.bool,
      onNodeToggle: i.a.func,
      onAction: i.a.func,
      onCheckboxChange: i.a.func,
      simpleSelect: i.a.bool,
      showPartiallySelected: i.a.bool,
      readOnly: i.a.bool
    };

    var ae = oe,
        ie = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        le = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var se = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return ce.call(n), n.computeInstanceProps(e), n.state = {
          items: n.allVisibleNodes.slice(0, n.props.pageSize)
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["Component"]), le(t, [{
        key: "render",
        value: function value() {
          var e = this.props.searchModeOn;
          return s.a.createElement("ul", {
            className: "root " + (e ? "searchModeOn" : ""),
            ref: this.setNodeRef
          }, this.state.scrollableTarget && s.a.createElement(E.a, {
            dataLength: this.state.items.length,
            next: this.loadMore,
            hasMore: this.hasMore(),
            loader: s.a.createElement("span", {
              className: "searchLoader"
            }, "Loading..."),
            scrollableTarget: this.state.scrollableTarget
          }, this.state.items));
        }
      }]), t;
    }();

    se.propTypes = {
      data: i.a.object,
      keepTreeOnSearch: i.a.bool,
      keepChildrenOnSearch: i.a.bool,
      searchModeOn: i.a.bool,
      onChange: i.a.func,
      onNodeToggle: i.a.func,
      onAction: i.a.func,
      onCheckboxChange: i.a.func,
      simpleSelect: i.a.bool,
      showPartiallySelected: i.a.bool,
      pageSize: i.a.number,
      readOnly: i.a.bool
    }, se.defaultProps = {
      pageSize: 100
    };

    var ce = function ce() {
      var e = this;
      this.componentWillReceiveProps = function (t) {
        e.computeInstanceProps(t), e.setState({
          items: e.allVisibleNodes.slice(0, e.props.pageSize)
        });
      }, this.componentDidMount = function () {
        e.setState({
          scrollableTarget: e.node.parentNode
        });
      }, this.computeInstanceProps = function (t) {
        e.allVisibleNodes = e.getNodes(t), e.totalPages = Math.ceil(e.allVisibleNodes.length / e.props.pageSize), e.currentPage = 1;
      }, this.getNodes = function (e) {
        var t = e.data,
            n = e.keepTreeOnSearch,
            r = e.keepChildrenOnSearch,
            o = e.searchModeOn,
            a = e.simpleSelect,
            i = e.showPartiallySelected,
            l = e.readOnly,
            c = e.onAction,
            u = e.onChange,
            h = e.onCheckboxChange,
            p = e.onNodeToggle,
            d = [];
        return t.forEach(function (e) {
          (function (e, t, n) {
            if (t || e.expanded) return !0;
            var r = e._parent && n.get(e._parent);
            return !r || r.expanded;
          })(e, o, t) && d.push(s.a.createElement(ae, ie({
            keepTreeOnSearch: n,
            keepChildrenOnSearch: r,
            key: e._id
          }, e, {
            searchModeOn: o,
            onChange: u,
            onCheckboxChange: h,
            onNodeToggle: p,
            onAction: c,
            simpleSelect: a,
            showPartiallySelected: i,
            readOnly: l
          })));
        }), d;
      }, this.hasMore = function () {
        return e.currentPage <= e.totalPages;
      }, this.loadMore = function () {
        e.currentPage = e.currentPage + 1;
        var t = e.allVisibleNodes.slice(0, e.currentPage * e.props.pageSize);
        e.setState({
          items: t
        });
      }, this.setNodeRef = function (t) {
        e.node = t;
      };
    },
        ue = se,
        he = n(5),
        pe = n.n(he),
        de = function de(e) {
      return e;
    },
        fe = function fe(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "children",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : de;
      return pe()(e[t], function (e) {
        return n(e).checked;
      }) || e[t].some(function (e) {
        return n(e).partial;
      });
    };

    var ye = function ye(e, t, n, r) {
      var o = function e(t) {
        var n = t.nodes,
            r = t.list,
            o = void 0 === r ? new Map() : r,
            a = t.parent,
            i = t.depth,
            l = void 0 === i ? 0 : i,
            s = t.simple,
            c = t.showPartialState,
            h = t.defaultValues,
            p = void 0 === h ? [] : h,
            d = t.hierarchical;
        return n.forEach(function (t, n) {
          t._depth = l, a ? (t._id = t.id || a._id + "-" + n, t._parent = a._id, a._children.push(t._id)) : t._id = t.id || "" + n, t.isDefaultValue && (p.push(t._id), t.checked = !0), d || function (e) {
            for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = ["checked", "disabled"], r = 0; r < n.length; r++) {
              var o = n[r];
              void 0 === e[o] && void 0 !== t[o] && (e[o] = t[o]);
            }
          }(t, a), o.set(t._id, t), !s && t.children && (t._children = [], e({
            nodes: t.children,
            list: o,
            parent: t,
            depth: l + 1,
            showPartialState: c,
            defaultValues: p,
            hierarchical: d
          }), c && !t.checked && (t.partial = fe(t), !u(t.children) && t.children.every(function (e) {
            return e.checked;
          }) && (t.checked = !0)), t.children = void 0);
        }), {
          list: o,
          defaultValues: p
        };
      }({
        nodes: Array.isArray(e) ? e : [e],
        simple: t,
        showPartialState: n,
        hierarchical: r
      });

      return {
        list: o.list,
        defaultValues: o.defaultValues
      };
    },
        be = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var ge = function () {
      function e(t) {
        var n = t.data,
            r = t.simpleSelect,
            o = t.showPartiallySelected,
            a = t.hierarchical;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._src = n;
        var i = ye(JSON.parse(JSON.stringify(n)), r, o, a),
            l = i.list,
            s = i.defaultValues;
        this.tree = l, this.defaultValues = s, this.simpleSelect = r, this.showPartialState = !a && o, this.searchMaps = new Map(), this.hierarchical = a;
      }

      return be(e, [{
        key: "getNodeById",
        value: function value(e) {
          return this.tree.get(e);
        }
      }, {
        key: "getMatches",
        value: function value(e) {
          var t = this;
          if (this.searchMaps.has(e)) return this.searchMaps.get(e);
          var n = -1,
              r = e;
          this.searchMaps.forEach(function (t, o) {
            e.startsWith(o) && o.length > n && (n = o.length, r = o);
          });
          var o = [];
          r !== e ? this.searchMaps.get(r).forEach(function (n) {
            var r = t.getNodeById(n);
            r.label.toLowerCase().indexOf(e) >= 0 && o.push(r._id);
          }) : this.tree.forEach(function (t) {
            t.label.toLowerCase().indexOf(e) >= 0 && o.push(t._id);
          });
          return this.searchMaps.set(e, o), o;
        }
      }, {
        key: "addParentsToTree",
        value: function value(e, t) {
          if (void 0 !== e) {
            var n = this.getNodeById(e);
            this.addParentsToTree(n._parent, t), n.hide = !0, n.matchInChildren = !0, t.set(e, n);
          }
        }
      }, {
        key: "addChildrenToTree",
        value: function value(e, t, n) {
          var r = this;
          void 0 !== e && e.forEach(function (e) {
            if (!n || !n.includes(e)) {
              var o = r.getNodeById(e);
              o.matchInParent = !0, t.set(e, o), r.addChildrenToTree(o._children, t);
            }
          });
        }
      }, {
        key: "filterTree",
        value: function value(e, t, n) {
          var r = this,
              o = this.getMatches(e.toLowerCase()),
              a = new Map();
          o.forEach(function (e) {
            var i = r.getNodeById(e);
            i.hide = !1, t && r.addParentsToTree(i._parent, a), a.set(e, i), t && n && r.addChildrenToTree(i._children, a, o);
          });
          var i = 0 === o.length;
          return this.matchTree = a, {
            allNodesHidden: i,
            tree: a
          };
        }
      }, {
        key: "restoreNodes",
        value: function value() {
          return this.tree.forEach(function (e) {
            e.hide = !1;
          }), this.tree;
        }
      }, {
        key: "restoreDefaultValues",
        value: function value() {
          var e = this;
          return this.defaultValues.forEach(function (t) {
            e.setNodeCheckedState(t, !0);
          }), this.tree;
        }
      }, {
        key: "togglePreviousChecked",
        value: function value(e) {
          var t = this.currentChecked;
          t && t !== e && (this.getNodeById(t).checked = !1), this.currentChecked = e;
        }
      }, {
        key: "setNodeCheckedState",
        value: function value(e, t) {
          var n = this.getNodeById(e);
          n.checked = t, this.showPartialState && (n.partial = !1), this.simpleSelect ? this.togglePreviousChecked(e) : (this.hierarchical || this.toggleChildren(e, t), this.showPartialState && this.partialCheckParents(n), this.hierarchical || t || this.unCheckParents(n));
        }
      }, {
        key: "unCheckParents",
        value: function value(e) {
          for (var t = e._parent; t;) {
            var n = this.getNodeById(t);
            n.checked = !1, n.partial = fe(n, "_children", this.getNodeById.bind(this)), t = n._parent;
          }
        }
      }, {
        key: "partialCheckParents",
        value: function value(e) {
          for (var t = this, n = e._parent; n;) {
            var r = this.getNodeById(n);
            r.checked = r._children.every(function (e) {
              return t.getNodeById(e).checked;
            }), r.partial = fe(r, "_children", this.getNodeById.bind(this)), n = r._parent;
          }
        }
      }, {
        key: "toggleChildren",
        value: function value(e, t) {
          var n = this,
              r = this.getNodeById(e);
          r.checked = t, this.showPartialState && (r.partial = !1), u(r._children) || r._children.forEach(function (e) {
            return n.toggleChildren(e, t);
          });
        }
      }, {
        key: "toggleNodeExpandState",
        value: function value(e) {
          var t = this.getNodeById(e);
          return t.expanded = !t.expanded, t.expanded || this.collapseChildren(t), this.tree;
        }
      }, {
        key: "collapseChildren",
        value: function value(e) {
          var t = this;
          e.expanded = !1, u(e._children) || e._children.forEach(function (e) {
            return t.collapseChildren(t.getNodeById(e));
          });
        }
      }, {
        key: "getTags",
        value: function value() {
          var e = this,
              t = [],
              n = {};
          return this.tree.forEach(function (r, o) {
            n[o] || (r.checked ? (t.push(r), e.hierarchical || function t(r) {
              n[r._id] = !0, u(r._children) || r._children.forEach(function (n) {
                return t(e.getNodeById(n));
              });
            }(r)) : n[o] = !0);
          }), t;
        }
      }]), e;
    }(),
        ve = n(4),
        me = n.n(ve),
        Oe = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        we = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();
    /*!
     * React Dropdown Tree Select
     * A lightweight, fast and highly customizable tree select component.
     * Hrusikesh Panda <hrusikesh.panda@dowjones.com>
     * Copyright (c) 2017 Dow Jones, Inc. <support@dowjones.com> (http://dowjones.com)
     * license MIT
     * see https://github.com/dowjones/react-dropdown-tree-select
     */


    var Te = o.a.bind(me.a),
        _e = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.createList = function (e) {
          var t = e.data,
              r = e.simpleSelect,
              o = e.showPartiallySelected,
              a = e.hierarchical;
          return n.treeManager = new ge({
            data: t,
            simpleSelect: r,
            showPartiallySelected: o,
            hierarchical: a
          }), n.treeManager.tree;
        }, n.resetSearchState = function () {
          return n.searchInput.value = "", {
            tree: n.treeManager.restoreNodes(),
            searchModeOn: !1,
            allNodesHidden: !1
          };
        }, n.handleClick = function () {
          n.setState(function (e) {
            var t = n.keepDropdownActive || !e.showDropdown;
            return t !== e.showDropdown && (t ? document.addEventListener("click", n.handleOutsideClick, !1) : document.removeEventListener("click", n.handleOutsideClick, !1)), t ? n.props.onFocus() : n.props.onBlur(), t ? {
              showDropdown: t
            } : Oe({
              showDropdown: t
            }, n.resetSearchState());
          });
        }, n.handleOutsideClick = function (e) {
          h(e, n.props.className) && n.handleClick();
        }, n.onInputChange = function (e) {
          var t = n.treeManager.filterTree(e, n.props.keepTreeOnSearch, n.props.keepChildrenOnSearch),
              r = t.allNodesHidden,
              o = t.tree,
              a = e.length > 0;
          n.setState({
            tree: o,
            searchModeOn: a,
            allNodesHidden: r
          });
        }, n.onTagRemove = function (e) {
          n.onCheckboxChange(e, !1);
        }, n.onNodeToggle = function (e) {
          n.treeManager.toggleNodeExpandState(e);
          var t = n.state.searchModeOn ? n.treeManager.matchTree : n.treeManager.tree;
          n.setState({
            tree: t
          }), "function" == typeof n.props.onNodeToggle && n.props.onNodeToggle(n.treeManager.getNodeById(e));
        }, n.onCheckboxChange = function (e, t) {
          n.treeManager.setNodeCheckedState(e, t);
          var r = n.treeManager.getTags(),
              o = !n.props.simpleSelect && n.state.showDropdown;
          r.length || (n.treeManager.restoreDefaultValues(), r = n.treeManager.getTags());
          var a = {
            tree: n.state.searchModeOn ? n.treeManager.matchTree : n.treeManager.tree,
            tags: r,
            showDropdown: o
          };
          (n.props.simpleSelect || n.props.clearSearchOnChange) && Object.assign(a, n.resetSearchState()), n.props.simpleSelect && document.removeEventListener("click", n.handleOutsideClick, !1), n.setState(a), n.props.onChange(n.treeManager.getNodeById(e), r);
        }, n.onAction = function (e, t) {
          "function" == typeof n.props.onAction && n.props.onAction(e, n.treeManager.getNodeById(t));
        }, n.onInputFocus = function () {
          n.keepDropdownActive = !0;
        }, n.onInputBlur = function () {
          n.keepDropdownActive = !1;
        }, n.state = {
          showDropdown: n.props.showDropdown || !1,
          searchModeOn: !1
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, l["Component"]), we(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.data,
              n = e.simpleSelect,
              r = e.showPartiallySelected,
              o = e.hierarchical,
              a = this.createList({
            data: t,
            simpleSelect: n,
            showPartiallySelected: r,
            hierarchical: o
          }),
              i = this.treeManager.getTags();
          this.setState({
            tree: a,
            tags: i
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener("click", this.handleOutsideClick, !1);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = e.data,
              n = e.simpleSelect,
              r = e.showPartiallySelected,
              o = e.hierarchical,
              a = this.createList({
            data: t,
            simpleSelect: n,
            showPartiallySelected: r,
            hierarchical: o
          }),
              i = this.treeManager.getTags();
          this.setState({
            tree: a,
            tags: i
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = Te({
            "dropdown-trigger": !0,
            arrow: !0,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly,
            top: this.state.showDropdown,
            bottom: !this.state.showDropdown
          });
          return s.a.createElement("div", {
            className: Te(this.props.className, "react-dropdown-tree-select"),
            ref: function ref(t) {
              e.node = t;
            }
          }, s.a.createElement("div", {
            className: "dropdown"
          }, s.a.createElement("a", {
            className: t,
            onClick: !this.props.disabled && this.handleClick
          }, s.a.createElement(P, {
            inputRef: function inputRef(t) {
              e.searchInput = t;
            },
            tags: this.state.tags,
            placeholderText: this.props.placeholderText,
            onInputChange: this.onInputChange,
            onFocus: this.onInputFocus,
            onBlur: this.onInputBlur,
            onTagRemove: this.onTagRemove,
            disabled: this.props.disabled,
            readOnly: this.props.readOnly
          })), this.state.showDropdown && s.a.createElement("div", {
            className: Te("dropdown-content")
          }, this.state.allNodesHidden ? s.a.createElement("span", {
            className: "no-matches"
          }, this.props.noMatchesText || "No matches found") : s.a.createElement(ue, {
            data: this.state.tree,
            keepTreeOnSearch: this.props.keepTreeOnSearch,
            keepChildrenOnSearch: this.props.keepChildrenOnSearch,
            searchModeOn: this.state.searchModeOn,
            onAction: this.onAction,
            onCheckboxChange: this.onCheckboxChange,
            onNodeToggle: this.onNodeToggle,
            simpleSelect: this.props.simpleSelect,
            showPartiallySelected: this.props.showPartiallySelected,
            readOnly: this.props.readOnly
          }))));
        }
      }]), t;
    }();

    _e.propTypes = {
      data: i.a.oneOfType([i.a.object, i.a.array]).isRequired,
      clearSearchOnChange: i.a.bool,
      keepTreeOnSearch: i.a.bool,
      keepChildrenOnSearch: i.a.bool,
      placeholderText: i.a.string,
      showDropdown: i.a.bool,
      className: i.a.string,
      onChange: i.a.func,
      onAction: i.a.func,
      onNodeToggle: i.a.func,
      onFocus: i.a.func,
      onBlur: i.a.func,
      simpleSelect: i.a.bool,
      noMatchesText: i.a.string,
      showPartiallySelected: i.a.bool,
      disabled: i.a.bool,
      readOnly: i.a.bool,
      hierarchical: i.a.bool
    }, _e.defaultProps = {
      onFocus: function onFocus() {},
      onBlur: function onBlur() {},
      onChange: function onChange() {}
    };
    t.default = _e;
  },,,,, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = n(14);

    function o() {}

    e.exports = function () {
      function e(e, t, n, o, a, i) {
        if (i !== r) {
          var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw l.name = "Invariant Violation", l;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }]);
});